var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,29.5h2v-7H15V25H12v2h3ZM20,27H36V25H20Zm11-5.5h2V19h3V17H33V14.5H31ZM12,19H28V17H12Zm4.5,23V38H7a2.88,2.88,0,0,1-2.1-.9A2.88,2.88,0,0,1,4,35V9a2.88,2.88,0,0,1,.9-2.1A2.88,2.88,0,0,1,7,6H41a2.88,2.88,0,0,1,2.1.9A2.88,2.88,0,0,1,44,9V35a3.08,3.08,0,0,1-3,3H31.5v4ZM7,35H41V9H7Zm0,0v0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.509892a6a7c1a0efc7040b79a14f7649.svg";
export { ForwardRef as ReactComponent };